module.exports = __webpack_public_path__ + "static/media/update_provider.74880554.png";